/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SubscriberQuestionnaireItemDto = {
    slug: Record<string, any>;
    type: SubscriberQuestionnaireItemDto.type;
    answers: Array<string>;
};

export namespace SubscriberQuestionnaireItemDto {

    export enum type {
        INPUT = 'input',
        CHECKBOX = 'checkbox',
        RADIO = 'radio',
        SELECT = 'select',
        TEXT_OPTIONS = 'text-options',
        BUTTONS = 'buttons',
    }


}

